<span *ngIf="value" [pTooltip]="value | amDateFormat: 'L LTS Z'">{{ value | amTimeAgo }}</span>
